import axios from './axiosConfig';
import Cookies from 'js-cookie';
import { apiConfig } from '../config/api.config';


const TOKEN_KEY = 'auth_token';
const TOKEN_EXPIRY_KEY = 'token_expires_in';
const USER_ID_KEY = 'user_id';

// 配置axios默认行为
axios.interceptors.request.use(
  config => {
    const token = Cookies.get(TOKEN_KEY);
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// SSO登录函数
export const ssoLogin = async (username, password) => {
  try {
    const response = await axios.post(`${apiConfig.getFullURL(`/auth/ssologin`)}`, {
      username,
      password
    });
    const token = response.data.data.token;
    const userId= response.data.data.userId;
    const expiresIn= response.data.data.expiresIn;
    const type= response.data.data.type;
    if (token) {
      // 存储认证信息到Cookie
      Cookies.set(TOKEN_KEY, token, { expires: expiresIn / (24 * 60 * 60) }); // 将秒转换为天
      Cookies.set(USER_ID_KEY, userId, { expires: expiresIn / (24 * 60 * 60) });
      Cookies.set(TOKEN_EXPIRY_KEY, expiresIn, { expires: expiresIn / (24 * 60 * 60) });
      return {
        success: true,
        userId,
        expiresIn,
        type
      };
    }

    return {
      success: false,
      message: '登录失败：未收到有效的token'
    };
  } catch (error) {
    return {
      success: false,
      message: `登录失败：${error.response?.data?.message || error.message}`
    };
  }
};

// 检查是否已登录
export const isAuthenticated = () => {
  return !!Cookies.get(TOKEN_KEY);
};

// 获取当前用户ID
export const getCurrentUserId = () => {
  return Cookies.get(USER_ID_KEY);
};

// 登出函数
export const logout = () => {
  Cookies.remove(TOKEN_KEY);
  Cookies.remove(USER_ID_KEY);
  Cookies.remove(TOKEN_EXPIRY_KEY);
};